module.exports = __webpack_public_path__ + "static/panel-a8ffbb751bda51a48ff4146f5551f020.png";